module.exports = __webpack_public_path__ + "sflyssofe.acebe79718.svg";